module.exports = __webpack_public_path__ + "assets/img/dx19.3703e205.jpg";